<template>
  <div>
    <div v-if="requestWaiting && !isBonusHistoryLoaded">{{ phrases.LOADING }}</div>
    <div v-else class="bonus-history">
      <div class="bonus-history-title">{{ phrases.CABINET_BONUS_HISTORY_TITLE }}</div>
      <div class="bonus-history-header">
        <div class="transaction-data">{{ phrases.CABINET_BONUS_HISTORY_DATE }}</div>
        <div class="transaction-type align-center">{{ phrases.CABINET_BONUS_HISTORY_INCOME }}</div>
        <div class="transaction-type align-center">{{ phrases.CABINET_BONUS_HISTORY_OUTCOME }}</div>
        <div class="transaction-value align-right">{{ phrases.CABINET_BONUS_HISTORY_TOTAL }}</div>
      </div>
      <div v-for="(historyItem, index) in bonusHistory" :key="index">
        <div class="bonus-history-item">
          <div class="transaction-data">{{ historyItem.date }}</div>
          <div class="transaction-type align-center">
            <span v-if="historyItem.type === 'income'">{{ parseInt(historyItem.value) }}</span>
            <span v-else>-</span>
          </div>
          <div class="transaction-type align-center">
            <span v-if="historyItem.type === 'outcome'">{{ parseInt(historyItem.value) }}</span>
            <span v-else>-</span>
          </div>
          <div class="transaction-value align-right">{{ parseInt(historyItem.total) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Utils from "../Utils";

export default {
  name: "BonusHistory",
  data: function(){
    return {
      requestWaiting: false
    };
  },
  computed:{
    ...mapGetters('app', {
      phrases: 'getPhrases',
    }),
    ...mapGetters('user', {
      bonusHistory: 'getBonusHistory',
      isBonusHistoryLoaded: 'isBonusHistoryLoaded',
    }),
  },
  mixins:[Utils],
}
</script>

<style scoped lang="scss">
  .bonus-history{
    .transaction-data,
    .transaction-type{
      width: 35%;
    }
    .transaction-value{
      width: 15%;
    }
    .align-center{
      text-align: center;
    }
    .align-right{
      text-align: right;
    }
    &-title{
      font-family: 'Panton Bold', sans-serif;
      font-size: 1.25rem;
    }
    &-header{
      display: flex;
      padding: 0.25rem;
      font-family: 'Panton SemiBold', sans-serif;
      font-size: 1.25rem;
    }
    &-item{
      border-bottom: 1px solid #a6a6a6;
      display: flex;
      .item-title{
        font-family: 'Panton SemiBold', sans-serif;
      }
      div{
        padding: 0.25rem;
      }
    }
  }
  
  @media all and (max-width: 600px) {
    .bonus-history{
      &-header {
        font-size: 1rem;
      }
      &-item{
        font-size: 0.87rem;
      }
    }
  }
</style>